import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const { REACT_APP_API_BASE_URL } = process.env;

const CAMPUS_INFO = '/v2/event/campus';
const CAMPUS_RANKINGS = '/v2/event/campus/rankings';


export const campusApi = createApi({
	reducerPath: 'campusApi',
	baseQuery: fetchBaseQuery({
        baseUrl: REACT_APP_API_BASE_URL,
    }),
	endpoints: (builder) => ({
        getCampus: builder.query({
            query: () => CAMPUS_INFO,
        }),
        getRankings: builder.query({
            query: () => CAMPUS_RANKINGS,
        }),
	})
});


export const {
    useGetCampusQuery,
    useLazyGetRankingsQuery,
} = campusApi;
